import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\RunAutomationDossierController::__invoke
* @see app/Http/Controllers/Dossier/RunAutomationDossierController.php
* @route '/api/dossier/{dossier}/automation/{automation}'
*/
const RunAutomationDossierController = (args: { dossier: string | number | { id: string | number }, automation: string | number | { id: string | number } } | [dossier: string | number | { id: string | number }, automation: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: RunAutomationDossierController.url(args, options),
    method: 'put',
})

RunAutomationDossierController.definition = {
    methods: ["put"],
    url: '/api/dossier/{dossier}/automation/{automation}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Dossier\RunAutomationDossierController::__invoke
* @see app/Http/Controllers/Dossier/RunAutomationDossierController.php
* @route '/api/dossier/{dossier}/automation/{automation}'
*/
RunAutomationDossierController.url = (args: { dossier: string | number | { id: string | number }, automation: string | number | { id: string | number } } | [dossier: string | number | { id: string | number }, automation: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
            automation: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
        automation: typeof args.automation === 'object'
        ? args.automation.id
        : args.automation,
    }

    return RunAutomationDossierController.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace('{automation}', parsedArgs.automation.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\RunAutomationDossierController::__invoke
* @see app/Http/Controllers/Dossier/RunAutomationDossierController.php
* @route '/api/dossier/{dossier}/automation/{automation}'
*/
RunAutomationDossierController.put = (args: { dossier: string | number | { id: string | number }, automation: string | number | { id: string | number } } | [dossier: string | number | { id: string | number }, automation: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: RunAutomationDossierController.url(args, options),
    method: 'put',
})

export default RunAutomationDossierController